import ufeApi from 'services/api/ufeApi';
import { gqlClient } from 'services/api/gql/gqlClient';
import { CancelOrder } from 'constants/gql/mutations/checkout/cancelOrder.gql';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Order+Cancel+API

/**
 * Cancels an order with the given reason.
 * Routes to OIS GraphQL (CancelOrder) or legacy OXS REST based on oisMigration feature flags.
 *
 * @param {Object} payload - Cancel order data
 * @param {string} payload.orderId - The order ID to cancel
 * @param {string} payload.reasonCode - Cancellation reason code
 * @param {string} [payload.otherReasonDescription] - Optional free-text cancellation description; included in the GraphQL input when a non-empty value is provided
 * @returns {Promise<Object>} The cancel order response
 * @throws {Object} Throws raw error object for OXS errors when errorCode is present
 * @throws {GraphQLException} Throws GraphQLException for OIS GraphQL failures
 */
const cancelOrder = async (payload = {}) => {
    const oxsUrl = '/api/checkout/orders/cancel';

    const globalEnabled = Sephora?.configurationSettings?.oisMigration?.global?.isEnabled;
    const cancelEnabled = Sephora?.configurationSettings?.oisMigration?.cancel?.isEnabled;

    if (globalEnabled && cancelEnabled) {
        const { orderId, reasonCode, otherReasonDescription } = payload;
        const input = { orderId, reasonCode };

        if (otherReasonDescription) {
            input.otherReasonDescription = otherReasonDescription;
        }

        const data = await gqlClient.query({
            operationName: 'CancelOrder',
            query: CancelOrder,
            variables: { input }
        });

        return data?.cancelOrder ?? data;
    }

    const data = await ufeApi.makeRequest(oxsUrl, {
        method: 'POST',
        body: JSON.stringify(payload)
    });

    if (data?.errorCode) {
        throw data;
    }

    return data;
};

export default cancelOrder;
